import React, { useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { insights } from '../mockData';
import Newsletter from '../components/Newsletter';
import { Clock, Calendar } from 'lucide-react';

const Insights = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const categories = ['All', 'Government Relations', 'Trading & Finance', 'Healthcare', 'Transportation', 'Technology'];

  const filteredInsights = selectedCategory === 'All' 
    ? insights 
    : insights.filter(insight => insight.category === selectedCategory);

  return (
    <div className="min-h-screen bg-black">
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-black via-[#1a1a1a] to-black"></div>
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-20 left-1/2 w-96 h-96 bg-[#C9A55A]/20 rounded-full blur-3xl"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Expert <span className="text-[#C9A55A]">Insights</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Industry analysis, trends, and thought leadership from our consulting experts
          </p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-8 bg-gradient-to-b from-black to-[#0a0a0a]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((category) => (
              <Button
                key={category}
                onClick={() => setSelectedCategory(category)}
                variant={selectedCategory === category ? "default" : "outline"}
                className={selectedCategory === category 
                  ? "bg-[#C9A55A] text-black hover:bg-[#B8941F]" 
                  : "border-white/20 text-gray-300 hover:border-[#C9A55A] hover:text-[#C9A55A]"
                }
              >
                {category}
              </Button>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Article */}
      <section className="py-12 bg-[#0a0a0a]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="relative h-96 rounded-lg overflow-hidden">
              <img 
                src={insights[0].image} 
                alt={insights[0].title}
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <div className="text-[#C9A55A] text-sm font-semibold mb-3">FEATURED INSIGHT</div>
              <h2 className="text-4xl font-bold text-white mb-4">{insights[0].title}</h2>
              <p className="text-gray-300 text-lg mb-6">{insights[0].excerpt}</p>
              <div className="flex items-center space-x-6 text-gray-400 text-sm mb-6">
                <div className="flex items-center space-x-2">
                  <Calendar size={16} />
                  <span>{insights[0].date}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Clock size={16} />
                  <span>{insights[0].readTime}</span>
                </div>
              </div>
              <Button className="bg-[#C9A55A] text-black hover:bg-[#B8941F] font-semibold">
                Read Article
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Insights Grid */}
      <section className="py-20 bg-gradient-to-b from-[#0a0a0a] to-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredInsights.slice(1).map((insight) => (
              <Card key={insight.id} className="bg-white/5 border-white/10 hover:border-[#C9A55A]/50 transition-all duration-300 overflow-hidden group cursor-pointer">
                <div className="relative h-56 overflow-hidden">
                  <img 
                    src={insight.image} 
                    alt={insight.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <CardContent className="p-6">
                  <div className="text-[#C9A55A] text-xs font-semibold mb-3">{insight.category}</div>
                  <h3 className="text-xl font-bold text-white mb-3 line-clamp-2">{insight.title}</h3>
                  <p className="text-gray-400 text-sm mb-4 line-clamp-3">{insight.excerpt}</p>
                  <div className="flex items-center justify-between text-xs text-gray-500 pt-4 border-t border-white/10">
                    <div className="flex items-center space-x-2">
                      <Calendar size={14} />
                      <span>{insight.date}</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <Clock size={14} />
                      <span>{insight.readTime}</span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <Newsletter />
    </div>
  );
};

export default Insights;